import {EventEmitter, Injectable} from '@angular/core';
import {Store} from "@ngxs/store";
import {RequestService} from "./request.service";

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private requestService: RequestService, private store: Store) { }

  async sendSolicitude(solicitude: any) {

    return this.requestService.post('register', { params: solicitude, ignoreToken: true });
  }

}
